module.exports = __webpack_public_path__ + "static/media/Caboo.fa776b1f.png";